export enum CalendarDataTestId {
  CALENDAR_PREVIOUS_MONTH_BUTTON = 'calendar-previous-month',
  CALENDAR_NEXT_MONTH_BUTTON = 'calendar-next-month',
}
